import React from 'react';
import { Mail } from "lucide-react";

const ForgotPasswordForm = ({
  identifier,
  setIdentifier,
  loading,
  errors,
  handleSubmit,
  isMobile = false
}) => {
  return (
    <div className={isMobile ? "space-y-3" : "space-y-8"}>
      <div className="space-y-3">
        <label className="flex items-center space-x-2 text-slate-700 font-bold text-sm">
          <Mail className="h-4 w-4" />
          <span>email address</span>
        </label>
        <input
          type="text"
          placeholder="Enter your email address"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          className={`w-full ${isMobile ? 'h-16 px-6 text-lg' : 'h-16 px-6 text-lg'} bg-slate-50 border-2 rounded-2xl focus:ring-4 focus:ring-teal-100 focus:outline-none transition-all duration-300 text-slate-800 placeholder-slate-400 hover:border-slate-300 ${errors.identifier ? 'border-red-500 focus:border-red-500' : 'border-slate-200 focus:border-teal-500'}`}
          disabled={loading}
        />
        {errors.identifier && (
          <p className="text-red-500 text-sm mt-1">{errors.identifier}</p>
        )}
      </div>

      <button
        onClick={handleSubmit}
        className="w-full h-16 bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-500 hover:from-teal-700 hover:via-teal-600 hover:to-cyan-600 text-white font-bold text-xl rounded-2xl shadow-2xl hover:shadow-teal-500/25 transform hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none"
        disabled={loading}
      >
        {loading ? (
          <div className="flex items-center justify-center space-x-3">
            <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Sending...</span>
          </div>
        ) : (
          'Send password reset link'
        )}
      </button>

      <div className="text-center mt-6 text-sm text-gray-600">
        <a
          href="/"
          className="text-sm text-teal-600 hover:text-teal-800 font-semibold transition-colors"
        >
          Login Page
        </a>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
